// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#kec li i {\n    margin-right: 10px;\n    font-size: 24px;\n}\n#kec p, #kec li, #kec .promise{\n    font-size: 16px;\n}\n#kec .promise span{\n    display: contents;\n}\n", ""]);
// Exports
module.exports = exports;
